import { MAPS_LINK } from "@/pages/home/constants";
import { reviews } from "@/mocks/reviews";

export default function Reviews() {
  return (
    <section id="resenas" className="w-full scroll-mt-24 bg-background-50">
      <div className="mx-auto w-full max-w-content px-4 py-16 md:px-6 md:py-24">
        <div className="reveal mx-auto mb-10 max-w-2xl text-center md:mb-14">
          <h2 className="text-3xl font-semibold md:text-[40px]">
            Lo que dicen quienes ya nos visitaron
          </h2>
          <div className="mt-5 inline-flex items-center gap-2 rounded-full bg-primary-100 px-4 py-2 text-sm font-label font-semibold text-primary-900">
            <i className="ri-star-fill text-primary-600" aria-hidden="true"></i>
            5,0 en Google · 74 reseñas
          </div>
        </div>

        <div className="grid grid-cols-1 gap-5 md:grid-cols-3 md:gap-6">
          {reviews.map((review) => (
            <figure
              key={review.id}
              className="reveal flex h-full flex-col rounded-2xl border border-background-200 bg-background-100 p-6"
            >
              <div className="flex gap-1 text-primary-600" aria-label="Calificación 5 de 5">
                {Array.from({ length: 5 }).map((_, index) => (
                  <i key={index} className="ri-star-fill text-base" aria-hidden="true"></i>
                ))}
              </div>
              <blockquote className="mt-4 flex-1 text-base leading-relaxed text-foreground-800">
                “{review.text}”
              </blockquote>
              <figcaption className="mt-5 text-sm font-label font-semibold text-foreground-500">
                {review.author}
              </figcaption>
            </figure>
          ))}
        </div>

        <div className="mt-10 text-center md:mt-12">
          <a
            href={MAPS_LINK}
            target="_blank"
            rel="noopener noreferrer"
            data-fb-event="VerResenas"
            className="inline-flex min-h-[44px] items-center gap-1.5 text-sm font-label font-semibold text-accent-700 cursor-pointer transition-colors hover:text-accent-800 md:text-base"
          >
            Ver todas las reseñas en Google
            <i className="ri-arrow-right-up-line text-base" aria-hidden="true"></i>
          </a>
        </div>
      </div>
    </section>
  );
}